import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEOProps } from '@/lib/geoai-types';



const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  url = "https://vexl-gis.tech", 
  image = "https://vexl-gis.tech/logo.png",
  type = "website",
  schema,
  lang = 'en',
  breadcrumbs,
  keywords
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}

      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:type" content={type === 'article' ? 'article' : 'website'} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="VEXL" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Structured Data (JSON-LD) for Google & AI Engines */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}

      {/* Breadcrumb Schema */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": breadcrumbs.map((crumb, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "name": crumb.name,
              "item": `${url}${crumb.item}`
            }))
          })}
        </script>
      )}

      {/* VEXL Base Organization Schema (Always injected if website type) */}
      {type === 'website' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "VEXL Studio",
            "url": "https://vexl-gis.tech",
            "logo": "https://vexl-gis.tech/logo.png",
            "sameAs": [
              "https://www.linkedin.com/company/vexl-studio",
              "https://x.com/vexl_tech",
              "https://github.com/vexl-gis",
              "https://www.instagram.com/vexl_official/"
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
